<template>
  <section class="truck">
    <drivers-header title="Мои авто" back="/more-items"/>
    <div class="driver">
      <div class="driver__title">Зарегистрированные автомобили </div>
      <div class="driver__content">
        <double-input-search
          title="Введите для поиска"
          class="truck__search"
          :show-search-list="showSearchTruck"
          :search-list="truckNumbers"
          :has-error="hasTruckError"
          :loading="loading"
          @input-changed="searchTruck"
          @input-blured="showResultTruck"
          @input-selected="selectResultTruck"
        />
        <el-table
          v-if="loading"
          v-loading="loading"
          :data="[]"
          element-loading-text="Загрузка..."
        />
        <template v-else>
          <auto-item
            v-for="auto in autoList"
            :key="auto.id"
            :auto="auto"
          />
          <div v-if="!autoList.length && !showSearchTruck" class="adding__nothing">
            <div class="adding__nothing-warning">
              {{ hasTruckError ? `По запросу “${searchValue}” ничего не найденно.` : 'Нет автомобилей для выбора' }}
            </div>
            <div class="adding__nothing-add">
              {{ hasTruckError ? 'Введите другой автомобиль или добавьте новый' : 'Добавьте автомобиль' }}
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AutoItem from './components/AutoItem'
import DoubleInputSearch from '@/components/Drivers/DoubleInputSearch/DoubleInputSearch'
import DriversHeader from '@/components/Drivers/DriversHeader/DriversHeader'

export default {
  name: 'AutosMobile',
  components: { AutoItem, DriversHeader, DoubleInputSearch },
  data() {
    return {
      showSearchTruck: false,
      hasTruckError: false,
      searchValue: '',
    }
  },
  computed: {
    ...mapGetters({
      autoList: 'autos/getAutos',
      loading: 'autos/getAutoLoading',
    }),
    // списки номеров авто для отображения в выпадашке инпута поиска
    truckNumbers() {
      return this.autoList.map(item => item.state_numbers)
    },
  },
  mounted() {
    this.loadPage()
  },
  methods: {
    ...mapActions({
      fetchAutosNew: 'autos/fetchAutosNew',
    }),
    async loadPage() {
      await this.fetchAutos()
    },
    fetchAutos(search = '') {
      this.fetchAutosNew({ org_id: this.curUserOrgId, search })
    },
    // обработка ввода значений в инпут поиска авто
    searchTruck(value) {
      this.hasTruckError = false

      if (value.length > 2) {
        this.fetchAutos(value)
        this.showSearchTruck = true
      }
      if (!value.length) {
        this.showSearchTruck = false
        this.fetchAutos()
      }
    },
    // конец ввода строки поиска авто
    showResultTruck(value) {
      this.showSearchTruck = false

      if (!this.autoList.length) {
        this.hasTruckError = true
        this.searchValue = value
      }
    },
    // выбор номера авто из выпадающего списка
    selectResultTruck(value) {
      this.fetchAutos(value)
      this.showSearchTruck = false
    },
  },
}
</script>

<style lang="sass" scoped>
@import "@/assets/styles/driver-styles.sass"
.truck__search
  margin-bottom: 1.2rem
.adding__nothing
  display: flex
  flex-direction: column
  justify-content: center
  height: 6.4rem
  border-top: 1px solid #D7D7D7
  &-warning
    margin-bottom: 0.2rem
    font-weight: 700
    font-size: 1.4rem
    line-height: 1.8rem
    color: #ED2121
  &-add
    font-weight: 400
    font-size: 1.2rem
    line-height: 1.6rem
    color: #747474
</style>
